import {Box, styled} from "@mui/material";
import React from "react";
import founderBackground from "../../assets/founderBackground.png";
import {contactsCEO, contactsCFA, contactsCOO, contactsCTO} from "../../config/team";
import TeamMember from "./TeamMember";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const founderDoc = require("../../files/Nikita_Pletnev_Founder_Portfolio.pdf");

const TeamContainer = styled(Box)({
    padding: "10px 20px 30px 20px",
    boxSizing: "border-box",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    background: "linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)), radial-gradient(circle at 50% 0%, #5f6b77 0%,#020508 56%)",
    "@media(max-width: 768px)":{
        backgroundPosition: "center 100%",
        backgroundSize: "250%",
    }
});

const TeamTitle = styled(Box)({
    fontSize: "3.5rem",
    fontWeight: 400,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        fontSize: "1.8rem",
    }
});

const TeamElementsContainer = styled(Box)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: "40px",
    rowGap: "40px",
    "@media(max-width: 768px)":{
        gridTemplateColumns: "1fr",
    }
});

const Team = ():JSX.Element => {
    return (
        <TeamContainer id={"team"}>
            <TeamTitle>
            Team:
            </TeamTitle>
            <TeamElementsContainer>
                <TeamMember avatar={founderBackground} title={"Nikita Pletnev"} description={"Founder & CEO"} contacts={contactsCEO}
                    docInDesc={{
                        name: "Nikita_Pletnev_Founder_Portfolio",
                        title: "Download Founder Portfolio",
                        file: founderDoc
                    }}/>
                <TeamMember avatar={"https://media.licdn.com/dms/image/v2/D4D03AQFxRkGCpooM_g/profile-displayphoto-shrink_800_800/B4DZTwCF26GkAo-/0/1739193868435?e=1759363200&v=beta&t=RO-pZzIWMgKkc6WB2lXI171g06m6q5h1aYu87Vi1nWo"} title={"Colin Reid"} description={"Co-Founder & COO"} contacts={contactsCOO}/>
                <TeamMember avatar={"https://media.licdn.com/dms/image/v2/C5603AQESr4vNQOp83A/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1543667130410?e=1759968000&v=beta&t=T65RcMEOfSoIw0Q1RLampC-4_sghugBLzxtSwxFsbEM"} title={"Dmitry Sergeev"} description={"CTO"} contacts={contactsCTO}/>
                <TeamMember avatar={"https://media.licdn.com/dms/image/v2/D5603AQGaUXo5QhZUqQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1715628322636?e=1759968000&v=beta&t=k3bxA2zDAPs1hqmyF6JmKvkc3qxWi5RQxwKcn7d4bRg"} title={"Jukka Hemmi"} description={"CFA"} contacts={contactsCFA}/>
            </TeamElementsContainer>
        </TeamContainer>
    );
};

export default Team;
